/**
 * Main Collection Section Logic (filter and sorting)
 * ------------------------------------------------------------------------
 * @summary ajax-based js logic on top of filter-sort form. Filtering and
 * sorting works natively without any js which means it's all handled server
 * side, js just makes it dynamic.
 *
 * How works: everytime an input is changed inside the filter-sort forms,
 * an event is fired ('filter:changed'), <main-collection> listens for that
 * event and then fetches the new section from the server. CollectionGrid then
 * refreshes it's own UI and fires back an event to <filter-sort> with the new
 * html so that <filter-sort> can take care re-rendering it's own UI elements.
 */

export class CollectionGrid extends HTMLElement {
    constructor() {
        super();

        this._selectors = {
            productGrid: "[js-products-grid]",
            toggleGrid: "[js-toggle-grid]",
            filterSort: "[js-filter-sort]",
            sortController: "[js-sort-controller]",
        };

        this._refresh = [
            "[js-products-grid]",
            "[js-pagination]",
            "[js-collection-sort]",
        ];

        // cache fetches for performance
        this._cache = [];
    }

    connectedCallback() {
        this._sort = this.querySelector(this._selectors.sortController);
        this._setListeners();
    }

    _setListeners() {
        document.addEventListener("filter:change", this._handleFilterChange);
        this._sort.addEventListener("change", this._handleSortOption);
    }

    _handleFilterChange = (evt) => {
        const { parsedHTML } = evt.detail;
        const scopedHTML = parsedHTML.querySelector(
            `[data-id="${this.dataset.id}"]`,
        );
        theme.utils.refreshElements(this._refresh, scopedHTML, this);
    };

    _handleSortOption = (evt) => {
        const target = evt.currentTarget;
        const sortValue = target.value;
        const select = document.querySelector("[js-filter-form-sort]");
        const form = document.querySelector("[js-filter-form]");
        select.value = sortValue;
        form.dispatchEvent(new Event("input"));
    };
}
